import React, { useState, useMemo } from 'react';
import PropTypes from 'prop-types';

import {
  UserLoginInputContext,
  ErrorMessageContext,
  HasPortalAccess
} from '.';

export default function ContextWrapper({ children }) {
  const [userLoginInput, setUserLoginInput] = useState({ email: '', password: '' });
  const [showErrorMessage, setShowErrorMessage] = useState('');
  const [hasPortalAccess, setHasPortalAccess] = useState(false);

  const userLoginInputProviderValue = useMemo(() => ({ userLoginInput, setUserLoginInput }), [userLoginInput]);
  const showErrorMessageProviderValue = useMemo(() => ({ showErrorMessage, setShowErrorMessage }), [showErrorMessage]);

  return (
    <UserLoginInputContext.Provider value={userLoginInputProviderValue}>
      <ErrorMessageContext.Provider value={showErrorMessageProviderValue}>
      <HasPortalAccess.Provider value={{ hasPortalAccess, setHasPortalAccess }}>
        {children}
      </HasPortalAccess.Provider>
      </ErrorMessageContext.Provider>
    </UserLoginInputContext.Provider>
  );
}

ContextWrapper.propTypes = { children: PropTypes.element.isRequired };
